import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_ELIGIBLE_ACCELERATOR_BONUS} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {EligibleAcceleratorBonusContent} from './EligibleAcceleratorBonusContent';
import reportPayload from './reportPayload';

export const EligibleAcceleratorBonusReport = ({
  loadingData = {total: null},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
  isViewTeam = false,
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'Eligible for Coach Accelerator Bonus')}
      description={tt(
        'description',
        'These Coaches are currently eligible for a Coach Accelerator bonus. Help encourage them to sign up new Clients this month to get it!',
      )}
      contentProps={{loadingData, showRecordPopover, isViewTeam}}
      contentComponent={EligibleAcceleratorBonusContent}
    />
  );
};

export default withHOC(
  withTranslation('report.eligibleAcceleratorBonusReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_ELIGIBLE_ACCELERATOR_BONUS,
    popoverContentProps: {},
  }),
)(EligibleAcceleratorBonusReport);
